import {API_HOST_NAME} from "../constants.js";
import useAuthenticatedResources from "../../../useAuthenticatedResources.js";

const useNodesResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/nodes`;
  return useAuthenticatedResources(url, {}, [
    { name: 'confirm', path: 'confirm', method: 'POST', member: true }
  ])
}

export default useNodesResources;
